// @flow
import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import Icon from '../Icon';
import I18n from '../../../lib/i18n';
import theme from '../../../theme-config';

const ToggleFrameButton = (props: Props) => {
  const styles = getStyles();
  return (
    <View style={styles.container}>
      {props.title && <Text style={styles.title}>{props.title}</Text>}
      <Icon
        color={theme.primaryColor}
        name="arrow-right"
        size={14}
        style={{ transform: [{ scaleX: I18n.rtl() ? -1 : 1 }] }}
      />
    </View>
  );
};

const getStyles = () =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    title: {
      fontSize: 13,
      color: theme.primaryColor,
      marginRight: 10,
    },
  });

type Props = {
  title: ?string,
};

export default ToggleFrameButton;
